import localStorage from 'local-storage';

import { branches, resolveBranch } from './config';

// Which tenant a request goes to when it does not name one itself. Shared by the axios
// interceptor and the redux-api-middleware injector so the two cannot drift again.
//
// Three rules, in order:
//
// 1. A request that already carries a TenantId keeps it. The account-activation and
//    password-reset pages set it from the `&branch=<pk>` in the emailed link, and that
//    link is the only thing that knows which tenant a signed-out person belongs to.
//    From 5.1.2 until this change the interceptors overwrote it, so every nscc client
//    who activated their account was activated under ONLINE; the API created their
//    questionnaire task in the wrong schema and left "Activate Account" pending in
//    nscc, which blanked their dashboard.
// 2. Otherwise a stored branch wins.
// 3. Otherwise, only when signed in, default to online. That default arrived in 5.1.2
//    with the change above and is kept for signed-in requests made before a branch is
//    stored. A signed-out request gets no tenant at all, as it did at v4.9.2, because
//    the API resolves sign-in and the forgot-password request from the email in the
//    body, and only when no header is sent.

export function hasTenantHeader(headers) {
  return Object.keys(headers || {}).some(
    (key) => key.toLowerCase() === 'tenantid' && Boolean(headers[key]),
  );
}

export function defaultTenant({ signedIn }) {
  const stored = Number(localStorage.get('branch'));
  if (branches[stored]) {
    return branches[stored];
  }
  return signedIn ? resolveBranch(stored) : undefined;
}
